import React from 'react';
import styled from 'App/styled';
import { getSearchHistory } from 'helpers/utils/search/searchSuggestion';
import { SearchSuggestion } from 'types/searchSuggestion';
import { searchTypes } from 'constants/searchSuggestion';
import SearchImage from './SearchImage';

const Wrapper = styled.div`
  background: #fff;
`;

const Button = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${(props) => props.theme.darkGrey};
  margin: 0;
  border: none;
  padding: 12px 16px;
  background: #fff;
  text-align: left;
  &:active {
    background: #e6e9eb;
  }
`;

const Icon = styled.span`
  height: 24px;
  width: 24px;
  margin-right: 16px;
  opacity: 0.48;
`;

const Text = styled.span`
  width: 100%;
  color: #001325;
  margin-right: 48px;
  ${({ theme }) => theme.typography.bodyMedium};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface Props {
  handleClick: (suggestion: SearchSuggestion, position: number) => void;
  searchSuggestionIcons: { history: string };
}

function History({ handleClick, searchSuggestionIcons }: Props) {
  let recentItems: SearchSuggestion[] = [];
  const searchItems = getSearchHistory();
  const { history } = searchSuggestionIcons;

  if (searchItems && searchItems.length > 0) {
    recentItems = searchItems;
  }

  const clickHandler = (
    searchSuggestion: SearchSuggestion,
    position: number
  ) => {
    searchSuggestion.listItemType = searchTypes.HISTORY;
    const searchItem = {
      ...searchSuggestion,
      id: position?.toString(),
    };

    handleClick(searchItem, position);
  };

  if (recentItems && recentItems.length > 0) {
    return (
      <Wrapper>
        {recentItems.map((recentItem, index) => {
          const { q, imageV2 } = recentItem;

          return (
            <Button
              type="button"
              key={q}
              onClick={() => {
                clickHandler(recentItem, index + 1);
              }}
            >
              <SearchImage
                imageV2={imageV2}
                IconComponent={
                  <Icon>
                    <img
                      src={history}
                      alt="clock icon"
                    />
                  </Icon>
                }
              />
              <Text>{q}</Text>
            </Button>
          );
        })}
      </Wrapper>
    );
  }

  return null;
}

export default History;
